var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtxc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94207 2.47392C8.85994 2.28829 9.15694 2.15667 9.23907 2.33329C11.1696 5.65879 13.1001 8.98598 15.0306 12.3165C14.9276 12.3165 14.8286 12.2828 14.7296 12.267L9.57713 11.2399C9.40838 11.2315 9.37126 10.9587 9.53607 10.9182L11.5577 10.3613C11.5818 10.3552 11.6042 10.3438 11.6234 10.328C11.6426 10.3123 11.6581 10.2924 11.6687 10.27C11.6794 10.2475 11.6849 10.223 11.685 10.1981C11.685 10.1732 11.6796 10.1487 11.6691 10.1262L8.94207 2.46942V2.47392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64563 2.49072C8.66419 2.51772 8.6805 2.54697 8.69456 2.57735C9.30544 4.30985 9.93206 6.04235 10.5384 7.77485C10.5924 7.91885 10.3899 8.03866 10.2909 7.93122C9.77119 7.38672 9.27619 6.82591 8.76487 6.28141C8.68219 6.20716 8.56238 6.25666 8.50894 6.33485L3.19613 12.5763C3.13425 12.6422 3.08081 12.7412 2.97731 12.7535C2.90306 12.7535 2.85356 12.6956 2.8125 12.6382V12.5426C4.75931 9.19347 6.70388 5.84322 8.64563 2.49072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01999 8.43465C7.11899 8.40596 7.25062 8.47571 7.21799 8.59553C7.01156 9.31328 6.79331 10.0271 6.57843 10.7403C6.54581 10.8315 6.62793 10.9136 6.71456 10.9181C9.495 11.475 12.2754 12.0521 15.0553 12.609C15.1093 12.6174 15.1464 12.6585 15.1875 12.6917V12.807L15.1087 12.8897H3.3075C4.545 11.4047 5.77856 9.91121 7.01999 8.43465Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtxc);
export default __webpack_public_path__ + "static/media/ctxc.31e85171cd8ef9cdfc78584cee185048.svg";
export { ForwardRef as ReactComponent };